import { render } from "./ReferenceSection.vue?vue&type=template&id=f707f34e&scoped=true"
import script from "./ReferenceSection.vue?vue&type=script&lang=js"
export * from "./ReferenceSection.vue?vue&type=script&lang=js"

import "./ReferenceSection.vue?vue&type=style&index=0&id=f707f34e&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f707f34e"]])

export default __exports__